export default "__VITE_ASSET__e8cdedf8__"